import React, { FC } from 'react';

import { Text } from '@chakra-ui/react';

import { StackedHeader } from 'components/DataDisplay';
import { ExclamationTriangleIcon } from 'components/Icons';
import { ConfirmationModal } from 'components/Overlay';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  handleSubmit: () => void;
  isLoading?: boolean;
}

export const EnableZeroTrustAccessConfirmationModal: FC<Props> = props => {
  const { isOpen, onClose, handleSubmit, isLoading } = props;

  return (
    <ConfirmationModal
      key={isOpen ? 'confirmation-open' : 'confirmation-closed'}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      name="CONFIRM"
      placeholder="Type CONFIRM to enable zero trust data access"
      header={
        <StackedHeader
          upper="Confirmation"
          lower=""
          icon={<ExclamationTriangleIcon />}
          color="red.600"
          bg="red.100"
          useCustomColor
          style={{ p: 1.5 }}
        />
      }
      confirmationText={
        <Text>
          By enabling, zero trust data access for sensitive data in your data
          source, you may impact any existing applications or users that rely on
          non-masked sensitive data to perform appropriate actions.
        </Text>
      }
      onConfirm={handleSubmit}
      isLoading={isLoading}
      label="OK"
    />
  );
};
